import styles from '../Pdf.module.css'
import {SmeIpidDoc} from '@peachy/assets'

// TODO src still has actual file path if element inspected
const IpidDocument = () => {
    return <iframe class={styles.pdf} src={SmeIpidDoc} />
}

export default IpidDocument
